import SettingsCard from './settings';
export default function(card) {
  switch(card) {
    case 'SettingsCard':
      return SettingsCard
    default:
      return SettingsCard
  }
}
